import { CircleSkeleton, Skeleton } from '@/_components';

type SectionHeadingProps = {
  withIcon?: boolean;
  withRightSlot?: boolean;
};

export function SectionHeadingSkeleton({ withIcon = true, withRightSlot = false }: SectionHeadingProps) {
  return (
    <header className="flex items-center justify-stretch gap-x-2">
      <div className="flex flex-1 items-center gap-x-2">
        {withIcon && <CircleSkeleton className="size-10" />}
        <div className="flex-1">
          <Skeleton className="h-7 w-3/4 max-w-44" />
        </div>
      </div>
      {withRightSlot && <Skeleton className="end h-7 w-12" />}
    </header>
  );
}
